import React from "react";
import "./uni.css";
import { useNavigate } from "react-router-dom";

export default function Russia() {
  const Navigate = useNavigate()

  return (
    <div className="vbgy">
      <div className="dfhtu">
        <h2>MBBS in Bangladesh</h2>
      </div>
      <div className="wityu">
        <img src="https://www.pgmedica.com/assets/img/blogs/36.png"></img>

        <p>
          Bangladesh officially the People's Republic of Bangladesh, is a
          country in South Asia. It is the eighth-most-populous country in the
          world, with a population of around 169 million people in an area of
          148,460 square kilometers (57,320 sq mi). Bangladesh is among the most
          densely populated countries in the world, and shares land borders with
          India to the west, north, and east, and Myanmar to the southeast; to
          the south it has a coastline along the Bay of Bengal. It is narrowly
          separated from Bhutan and Nepal by the Siliguri Corridor; and from
          China by the Indian state of Sikkim in the north. Dhaka, the capital
          and largest city, is the nation's political, financial and cultural
          centre. Chittagong is the busiest port on the Bay of Bengal.
          <br />
          <br />
          <button onClick={()=>{Navigate('/contact')}}>Apply Now</button>
        </p>
      </div>

      {/* 00000000000000000000000000000000000000000000000000000 */}

      <div className="nffd">
        <img src="https://www.themdhouse.com/blog/wp-content/uploads/2020/08/mbbs-in-bangladesh.jpg"></img>
        <div className="nhjip">
          <h3
            style={{
              backgroundColor: "#ff9818",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            A BRIEF LOOK AT MBBS In BANGLADESH
          </h3>
          <br />
          <br />
          <table className="ewrfd">
            <tr>
              <td>Capital</td>
              <td>Dhaka</td>
            </tr>
            <tr>
              <td>Population</td>
              <td>16.94 crores (2021)</td>
            </tr>
            <tr>
              <td>Language</td>
              <td>Bengali</td>
            </tr>
            <tr>
              <td>Medium of Instruction</td>
              <td>English</td>
            </tr>
            <tr>
              <td>Currency</td>
              <td>Bangladeshi Taka (1 Taka = 0.77 INR)</td>
            </tr>
            <tr>
              <td>International Airport</td>
              <td>Dhaka</td>
            </tr>
            <tr>
              <td>Recognition</td>
              <td>NMC (MCI), WHO, ECFMG, FAIMER, WDOMS</td>
            </tr>
            <tr>
              <td>Course Duration</td>
              <td>6 Years(5 + 1 Year's internship)</td>
            </tr>
            <tr>
              <td>Average cost of stay (Fee included)</td>
              <td>25-50 lakhs(Approx)</td>
            </tr>
            <tr>
              <td>Intake</td>
              <td>Summer & Winter</td>
            </tr>
          </table>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000    */}
      <div className="cxdsf">
        <div className="ugvuids">
          <h2>UNIVERSITY OF BANGLADESH</h2>
          <table className="table" data-aos="zoom-in-up" data-aos-duration="1000" data-aos-easing="linear">
                <tr>
                    <th className="th title2">UNIVERSITY NAME</th>
                    <th className="th title">AFFILIATED UNIVERSITY</th>
                    <th className="th title2">TUTION FEE</th>
                    <th className="th title2">HOSTAL FEE</th>
                    <th className="th title2">OTC</th>
                </tr>
                {/* <!-- 1 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>1.</span>Jalalabd Ragib Rabeya Medical College</td>
                    <td className="td">SMU</td>
                    <td className="td">45,950$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 2 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>2.</span>President Abdul Hamid Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">39,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 3 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>3.</span>Dhaka Community Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">42,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                
                {/* <!-- 4 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>4.</span>Ad-din Women's Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">36,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                
                {/* <!-- 5 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>5.</span>Ad-din Sakina Women's Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">36,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                
                {/* <!-- 6 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>6.</span>Ad-din Akij Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">36,000$</td>
                    <td className="td">100$ P/M</td>
                    <td className="td">Extra</td>
                </tr>
                
                {/* <!-- 7 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>7.</span>Bashundhara Ad-din Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">36,000$</td>
                    <td className="td">150$ P/M</td>
                    <td className="td">Extra</td>
                </tr>
                
                {/* <!-- 8 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>8. </span>MH Shamarita Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">42,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 9 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>9. </span>Popular Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">45,000$</td>
                    <td className="td">Extra</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 10 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>10. </span>Dhaka National Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">48,000$</td>
                    <td className="td">Extra</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 11 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>11.</span>Holy Family Red Crescent Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">50,250$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 12 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>12</span>Central Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">39,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 13 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>13 </span>US-Bangla Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">35,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 14 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>14. </span>IBN-Sina Medical College </td>
                    <td className="td">DU</td>
                    <td className="td">40,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 15 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>15. </span>North East Medical College</td>
                    <td className="td">SMU</td>
                    <td className="td">44,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 16 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>16. </span>North Bengal Medical College</td>
                    <td className="td">RMU</td>
                    <td className="td">35,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 17 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>17. </span>Jaharul lshlam Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">40,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 18 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>18. </span>Bangladesh Medical College       </td>
                    <td className="td">DU</td>
                    <td className="td">49,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 19 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>19. </span>Tbilisi State Medical University</td>
                    <td className="td">DU</td>
                    <td className="td">300&</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 20 --> */}
                    <tr>
                    <td className="td dflex dflexMob"><span>20. </span>BGC Trust Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">33,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                 {/* <!-- 21 --> */}
                 <tr>
                    <td className="td dflex dflexMob"><span>20. </span>City Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">37,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                 {/* <!-- 22 --> */}
                 <tr>
                    <td className="td dflex dflexMob"><span>22. </span>Enam Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">36,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                 {/* <!-- 23 --> */}
                 <tr>
                    <td className="td dflex dflexMob"><span>23. </span>Anwer Khan Medical Colege</td>
                    <td className="td">DU</td>
                    <td className="td">44,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 24 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>24. </span>Dhaka Central Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">37,500$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 25 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>25. </span>Park View Medical College</td>
                    <td className="td">SMU</td>
                    <td className="td">34,500$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 26 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>26. </span>SylhetWomen's Medical College</td>
                    <td className="td">SMU</td>
                    <td className="td">40,000$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 27 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>27. </span>Rangpur Community Medical College</td>
                    <td className="td">RMU</td>
                    <td className="td">39,950$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                {/* <!-- 28 --> */}
                <tr>
                    <td className="td dflex dflexMob"><span>28. </span>Mono Medical College</td>
                    <td className="td">DU</td>
                    <td className="td">41,500$</td>
                    <td className="td">Included</td>
                    <td className="td">Extra</td>
                </tr>
                
            </table>
        </div>
      </div>
      <section className="ugvui">
      <ul>
                <li className="para"  data-aos="fade-down" data-aos-duration="1000" data-aos-easing="linear"><span>■</span>Above mentioned tution fee changable according to their academic session.</li>
    
                
            </ul>
      </section>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000 */}

      {/* <div className="gsfas">
        <h3>BASHKIR STATE MEDICAL UNIVERSITY</h3>

        <div className="sdgdfghf">
          <img src="https://www.metaeducationindia.com/wp-content/uploads/2021/02/Bashkir-state-medical-university.jpg"></img>
          <p>
            Bashkir State Medical University was established in 1932. It is one
            of the leading medical universities in the Russian Federation. With
            more than 8000 students from 40 different countries, it is the most
            suitable choice for MBBS in Russia. Formerly introduced as
            Bashkortostan Institute in Ufa, Bashkir State Medical University is
            the top institution in the center of the medical and pharmaceutical
            sciences of the Republic of Bashkortostan.
            <br />
            <strong>pESTO. : 1932</strong>
            <br />
            <strong>University Type : Government</strong>
            <br />
            <strong>Medium : English</strong>
            <br />
            <strong>ESTO. : No. of Indian Students : 500+</strong>
            <br />
          </p>
        </div>
      </div> */}

      {/* 0000000000000000000000000000000000000000000000000 */}

      {/* <div className="packageForFirstYear">
        <table className="table fgjhfghfg" border="1">
          <h2 style={{ textAlign: "center", width: "100%" }}>
            PACKAGE FOR 1ST YEAR STUDENT
          </h2>
          <thead>
            <tr rules="rows">
              <td>TUITION FEE</td>
              <td>HOSTEL FEE</td>
              <td>
                IMMIGRATION CLERANCE,AIRPORT PICKUP, ARRIVAL MEAL, TRANSLATION
                AND ATTESTATION OF DOCUMENTS IN UNIVERSITY, MEDICAL INSURANCE &
                MEDICAL CHECKUP, LOCAL POLICE VERIFICATION, BIOMETRIC AND VISA
                EXTENTION, HOSTEL ALLOTMENT, BANK ACCOUNT OPENING, LOCAL SUPPORT
                ETC
              </td>
              <td>INCENTIVE</td>
            </tr>

            <tr>
              <td>2.94,120RUB</td>
              <td>13,00RUB</td>
              <td>2300$</td>
              <td>1000$</td>
            </tr>
          </thead>
        </table>
        <p className="para border">FOOD FEE PER MONTH - 120$</p>
        <p className="para border pb0">
          ADMISSION FEE, VISA PROCESSING & DOCUMENTATION ( 25-35000) | FLIGHT
          TICKET AS PER ACTUAL.
        </p>
      </div> */}

      {/* 000000000000000000000000000000000000000000000000000000000000000 */}

      {/* <div
        className="packageForSixYear"
        data-aos="zoom-out"
        data-aos-duration="1000"
        data-aos-easing="linear"
      >
        <h3 className="packagewhite">PACKAGE FOR 2ND TO 6TH YEAR STUDENT</h3>
        <table className="table">
          <tr>
            <th className="th title2">Package</th>
            <th className="th title2">2nd</th>
            <th className="th title2">3rd</th>
            <th className="th title2">4th</th>
            <th className="th title2">5th</th>
            <th className="th title2">6th</th>
          </tr>

          <tr>
            <td className="td ">Tuition Fee</td>
            <td className="td">2,94,120RUB</td>
            <td className="td">2,94,120RUB</td>
            <td className="td">2,94,120RUB</td>
            <td className="td">2,94,120RUB</td>
            <td className="td">2,94,120RUB</td>
          </tr>

          <tr>
            <td className="td">Hostel Fee</td>
            <td className="td">13,000RUB</td>
            <td className="td">13,000RUB</td>
            <td className="td">13,000RUB</td>
            <td className="td">13,000RUB</td>
            <td className="td">13,000RUB</td>
          </tr>

          <tr>
            <td className="td">Medical Insurance VISA Extention</td>
            <td className="td">200$</td>
            <td className="td">200$</td>
            <td className="td">200$</td>
            <td className="td">200$</td>
            <td className="td">200$</td>
          </tr>
        </table>
      </div>

      <div className="mainSec">
        <ul>
          <li className="para">
            <span>
              {" "}
              IMPORTANT NOTE <b>:</b>
            </span>
            <br />
            <br />
            <p
              data-aos="zoom-out"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              BSMU has a huge clinic where over 24000 patients visit annually
              which helps students to be in practical touch. <br />
            </p>
            <p
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              Bashkir State Medical University provides Simulation Based
              Training in the Simulation Centre.
              <br />
            </p>
            <p
              data-aos="zoom-out"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              The University provides Russian language training for bilingual
              coaching.
              <br />
            </p>
            <p
              data-aos="zoom-in"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              University has a diverse culture with 8000 foreign students coming
              from 40 different countries. <br />
            </p>
            <p
              data-aos="zoom-out"
              data-aos-duration="1000"
              data-aos-easing="linear"
            >
              There are fully equipped laboratories with modern equipment.
            </p>
          </li>
        </ul>
      </div> */}
    </div>
  );
}
